const types = {
    SIGN_UP: 'SIGN_UP',
    LOG_IN_REQUEST: 'LOG_IN_REQUEST',
    MESSAGE_AUTH: 'MESSAGE_AUTH',
    SHOW_LOADING_LOGIN: 'SHOW_LOADING_LOGIN',
    LOG_IN_SUCCESS: 'LOG_IN_SUCCESS',
    IS_REMEMBER_LOG_IN: 'IS_REMEMBER_LOG_IN',
    REMEMBER_LOG_IN_SUCCESS: 'REMEMBER_LOG_IN_SUCCESS',
    LOG_OUT_SUCCESS: 'LOG_OUT_SUCCESS',
};

export default types;